<template>
  <b-modal title="Informações Sobre a Veículo" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="3" label-align="right">
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Cor:" label-for="cor" label-cols="3" label-align="right">
            <b-form-input id="cor" v-model="editing.cor" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Placa:" label-for="placa" label-cols="3" label-align="right">
            <b-form-input id="placa" v-model="editing.placa" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Renavam:" label-for="renavam" label-cols="3" label-align="right">
            <b-form-input id="renavam" v-model="editing.renavam" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Ano:" label-for="ano" label-cols="3" label-align="right">
            <b-form-input id="ano" v-model="editing.ano" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Emplacamento:" label-for="emplacamento" label-cols="3" label-align="right">
            <b-form-input id="emplacamento" v-model="editing.emplacamento" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Documento:" label-cols="3" label-align="right">
            <b-form-file type="file" class="text-left mt-1" v-model="arquivo" placeholder="Solte aqui .jpg" accept=".jpg" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useVeiculoStore } from "@/stores/VeiculoStore";
import Veiculo from "@/models/Veiculo";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";

export default {
  name: "ModalDeEdicaoDeVeiculo",

  data() {
    return {
      show: false,
      editing: new Veiculo(0, "Novo Transporte", "", "", "", "", ""),
      files: new Files(this.$http),
      arquivo: null,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.veiculoStore.ALTERAR_VEICULO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Veículo foi salvo no SGCQ com sucesso!", "Excelente!", "success"));
          if (this.arquivo != null) {
            const filename = this.editing.id + ".jpg";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadCrlv(filename, formData);
          }
        });
      } else {
        this.veiculoStore
          .CADASTRAR_VEICULO(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Veículo foi salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(veiculo) {
      this.show = !this.show;
      this.editing = veiculo;
    },
  },

  setup() {
    const store = useSgcqStore();
    const veiculoStore = useVeiculoStore();

    return {
      store,
      veiculoStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
